module.exports = __webpack_public_path__ + "static/img/jyzz.962ad85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/jyzz.png
// module id = seel
// module chunks = 1